import React from "react";
import style from "./DebridementCommon.module.scss";
import { ReadOnlyBanner } from "../../../../../secondary/ReadOnlyBanner/ReadOnlyBanner";
import { signedLockedAccess } from "../../../../../../utils";
import { Button, Form, SelectBox } from "../../../../../primary";
import { NOT_PERFORMED_REASONS } from "../debridementConfig";
import { PrerequisiteBlock } from "./PrerequisiteBlock";
import { ProcedureBlock } from "./ProcedureBlock";
import { OutcomeBlock } from "./OutcomeBlock";
import { CANCEL_BTN, SAVE_BTN } from "../../../../../../constants";
import { PERMISSIONS } from "../../../../../../constants/permissions";
import { InfoBanner } from "../../../../../secondary/ReadOnlyBanner/InfoBanner";
import constants from "../../../../../../constants/constants.json";

/**
 * Debridement — edit mode.
 *
 * Block 0  Router        Was debridement performed?
 * Block 1  Prerequisites Collapsible. Non-terminal.
 * Block 2  Procedure     What was done.
 * Block 3  Outcome       Captured after.
 *
 */

export const DebridementEditMode = ({
  assessmentDetails,
  handleSubmit,
  doSubmit,
  register,
  errors,
  setFormChangesConfirm,
  form,
  careSetting,
  prerequisites,
  flags,
  readiness,
  reasonGaps,
  showReasonErrors,
  performed,
  showApproach,
  showSubcutaneous,
  showPressure,
  readyOpen,
  setReadyOpen,
  setField,
  toggleMulti,
  setPrerequisiteAnswer,
  setPrerequisiteSelection,
  setPrerequisiteReason,
  onCancelClick,
  isReadOnly,
  instrumentsUsedRef,
  necroticTissueRef,
  onMultiSelect,
  control,
  submitLoading,
}) => (
  <div className={style.cont_spac}>
    {isReadOnly && <ReadOnlyBanner />}

    {!signedLockedAccess(assessmentDetails?.assessmentStage) && <InfoBanner message={constants.assessment.assessmentSignedLoked} />}

    <Form
      setFormChangesConfirm={setFormChangesConfirm}
      formChanges
      onSubmit={handleSubmit(doSubmit)}
      requiredPermission={PERMISSIONS.TREATMENT}
      disabled={!signedLockedAccess(assessmentDetails?.assessmentStage)}
    >
      {/* ---- Block 0 · router --- */}
      <section className={style.block}>
        <div className={style.block_head_static}>
          <span className={style.block_num}>0</span>
          <span className={style.block_title}>Was debridement performed?</span>
        </div>
        <div className={style.block_body}>
          <div className={style.field} style={{ maxWidth: "320px" }}>
            <SelectBox
              id="isDebridementPerformed"
              name="isDebridementPerformed"
              optionValue={[
                { key: "yes", value: "Yes" },
                { key: "no", value: "No" },
              ]}
              defaultValue={form.isDebridementPerformed || ""}
              disabled={isReadOnly}
              classes={{ inputClassName: style.custom_basic_select }}
              onChange={(e) => setField("isDebridementPerformed", e.target.value)}
            />
          </div>

          {!performed && (
            <div className={style.field2} data-testid="not-performed-reason">
              <label htmlFor="notPerformedReason">
                Reason not performed <span className={style.astrick}>*</span>
              </label>
              <SelectBox
                id="notPerformedReason"
                name="notPerformedReason"
                optionValue={NOT_PERFORMED_REASONS}
                defaultValue={form.notPerformedReason || ""}
                placeholder="Select…"
                disabled={isReadOnly}
                classes={{ inputClassName: style.custom_basic_select, column: style.w50 }}
                onChange={(e) => setField("notPerformedReason", e.target.value)}
                validator={register({
                  required: "This field is required",
                })}
                errors={errors}
              />
            </div>
          )}
        </div>
      </section>
      {performed && (
        <>
          {/* ---- Block 1 · prerequisites ---- */}
          <PrerequisiteBlock
            prerequisites={prerequisites}
            careSetting={careSetting}
            answers={form.prerequisiteAnswers}
            readiness={readiness}
            flagCount={flags.length}
            open={readyOpen}
            setReadyOpen={setReadyOpen}
            onAnswer={setPrerequisiteAnswer}
            onSelection={setPrerequisiteSelection}
            onReason={setPrerequisiteReason}
            reasonGaps={reasonGaps}
            showReasonErrors={showReasonErrors}
            disabled={isReadOnly || !performed}
            register={register}
            errors={errors}
            control={control}
          />

          {/* ---- Block 2 · procedure ---- */}
          <ProcedureBlock
            form={form}
            showApproach={showApproach}
            showSubcutaneous={showSubcutaneous}
            disabled={isReadOnly || !performed}
            onField={setField}
            onToggleMulti={toggleMulti}
            register={register}
            errors={errors}
            necroticTissueRef={necroticTissueRef}
            instrumentsUsedRef={instrumentsUsedRef}
            onMultiSelect={onMultiSelect}
          />

          {/* ---- Block 3 · outcome ---- */}
          <OutcomeBlock form={form} showPressure={showPressure} disabled={isReadOnly || !performed} onField={setField} />
        </>
      )}

      {
        <div className={style.action_submit}>
          <Button type="button" id="cancel" value={CANCEL_BTN} classes={{ className: `btn ${style.btn_cancel}` }} onClick={onCancelClick} />
          <Button type="submit" id="updateBtn" classes={{ className: `btn ${style.btn_save} ${style.d_flex}` }} disabled={submitLoading}>
            {submitLoading && <div className={style.custom_spinner}></div>} {SAVE_BTN}
          </Button>
        </div>
      }
    </Form>
  </div>
);
